import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from '../../../../services/lookups/lookup.service';
import { LookupAdminService } from '../../../../services/lookups/lookupadmin.service';
import {Location} from '../../../../models/user.model';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-division-detail',
  templateUrl: './division-detail.component.html',
  styleUrls: ['./division-detail.component.css']
})
export class DivisionDetailComponent implements OnInit {
  programAreas: Location[] = [];
  @Output() showHideDivisionDetailDlg = new EventEmitter<boolean>();
  @Output() refreshDataSource=new EventEmitter<boolean>();
  divisionDetailForm: FormGroup;

  constructor(private fb: FormBuilder, 
              private lookupService: LookupService,
              private lookupAdminService:LookupAdminService,
              private notifier: NotifierService) {}

  ngOnInit() {
    this.divisionDetailForm = this.fb.group({
      Id: [''],
      divisionName: ['', [Validators.required, Validators.pattern(/^[ A-Za-z0-9_'-]*$/)]],
      programArea: ['', Validators.required],
      isActive:['',Validators.required],
      //lastUpdatedBy:[''],
      lastUpdatedDateTime:['']
    });
  }

  showDivisionDetailDialog(location: Location) {
    // console.log(id);
    //this.lookupService.getRootLocations(this.authUser._user.userType.typeName).subscribe((data: Location[]) => {
      this.lookupService.getAllProgramAreas$().subscribe((data: Location[]) => {
      this.programAreas = data;
      this.programAreas.sort(
        (a, b): number => {
          if (a.locationName < b.locationName) return -1;
          if (a.locationName > b.locationName) return 1;
          return 0;
        }
      );
    });
    
    if(location!=null)
    {
      //console.log(location);
      this.divisionDetailForm.patchValue({
          Id:location.id,
          divisionName:location.locationName,
          programArea:location.parentLocation,
          isActive :String(location.isActive),
          lastUpdatedDateTime : new Date(location.lastUpdatedDateTime).toLocaleString()
      });
    }
    else
    {
      this.divisionDetailForm.reset();
    }

  }

  onCancelDivisionDetail()
  {
    this.divisionDetailForm.reset();
    this.showHideDivisionDetailDlg.emit(false);
    this.refreshDataSource.emit(true);

  }
  onSaveDivisionDetail()
  {
       if(this.divisionDetailForm.valid)
       {
         let division = Object.assign(new Location(),this.divisionDetailForm.value);
         division.parentId = division.programArea.id;
         division.locationName = division.divisionName;
         this.lookupAdminService.saveDivision(division).subscribe((resp)=>{
           if(resp.ok)
           {
            this.notifier.notify('success', 'Division saved successfully');
           }

       },error=>{
          this.notifier.notify('error', 'Failed to save Division, contact tech support');
          });
         
       
       }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/lookup-management/division/division-detail/division-detail.component.ts